import { render, staticRenderFns } from "./RegistrationFormAddPage.vue?vue&type=template&id=0889837a&scoped=true&"
import script from "./RegistrationFormAddPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormAddPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormAddPage.vue?vue&type=style&index=0&id=0889837a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889837a",
  null
  
)

export default component.exports